import React from "react";
import { FileSearch, ArrowRight, Lock } from "lucide-react";
import { Reveal } from "../hooks/useReveal";
import { TRUST_PORTAL_URL } from "../data/siteContent";

const FreeReview = () => {
  return (
    <section className="bg-parchment py-24 sm:py-36" data-testid="have-trust-section">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="bg-white border border-ink/10 rounded-3xl p-8 sm:p-16 shadow-xl relative overflow-hidden">
            <div
              className="absolute top-0 right-0 w-64 h-64 bg-goldeep/8 blur-3xl rounded-full"
              aria-hidden="true"
            />
            <div className="flex items-start gap-6 flex-col sm:flex-row">
              <div className="w-16 h-16 rounded-full bg-goldeep/10 border border-goldeep/30 flex items-center justify-center text-goldeep shrink-0">
                <FileSearch className="w-[26px] h-[26px]" strokeWidth={1.8} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
                  <span className="h-px w-10 bg-gold/60" />
                  Free Review
                </div>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl text-ink tracking-tight leading-[1.08] mt-5">
                  Already Have a Trust. <em className="text-goldeep italic">Let Me See It.</em>
                </h2>
                <p className="text-ink/70 text-base sm:text-lg leading-relaxed mt-6">
                  Good. Most people do not. But here is what I have learned.
                  Most trusts are either sitting empty, missing key
                  protections, or were written under laws that have since
                  changed.
                </p>
                <p className="text-ink/70 text-base sm:text-lg leading-relaxed mt-4">
                  Bring it to me. I will review it at no cost and tell you
                  exactly where you stand. If it is solid I will tell you. If
                  there is a gap I will show you and I will show you what it
                  takes to close it.
                </p>
                <a
                  href={TRUST_PORTAL_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="upload-trust-btn"
                  className="group inline-flex items-center gap-3 bg-ink text-cream font-bold text-sm tracking-[0.1em] uppercase px-8 py-4 rounded-full mt-9 hover:bg-goldeep transition-colors duration-300"
                >
                  Upload Your Trust for Free Review
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </a>
                <p className="text-ink/50 text-sm mt-5 tracking-wide">
                  No cost. No commitment. Just answers.
                </p>
                <p
                  className="flex items-start gap-2 text-ink/55 text-xs sm:text-sm leading-relaxed mt-4"
                  data-testid="upload-security-statement"
                >
                  <Lock className="w-[14px] h-[14px] text-goldeep shrink-0 mt-0.5" />
                  All personal information you provide, including Social
                  Security Numbers, is protected with military grade AES 256
                  GCM encryption.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FreeReview;
